import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { DesignTabContainerVM, IDesignTabContainerProps } from './DesignTabContainerVM';
import { CollapseMenu } from '../../common/CollapseMenu/CollapseMenu';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { FlatButton } from 'nrcs-design-system';
import { mdiAccountCog } from '@mdi/js';
import './DesignTabContainer.scss';
import stores from 'cd-eft/models/Stores';

const designStore = stores.AppStore.designStore;

const DesignTabContainerComponent = (props: IDesignTabContainerProps) => {
  const vm = useRef(new DesignTabContainerVM(props)).current;

  return (
    <>
      {vm.store.showLoader && !designStore.isLoading ? <Loader /> : null}

      <CollapseMenu
        title={vm.title}
        cardBodyId="structure-design"
        noIcon={true}
        forceOpen={true}
        className="design-tab-container"
      >
        <div className="tab-design-list-container">
          <div className="rcn-top-nav design-list-tabs">
            <ul>
              <li className="table-name">
                <button
                  data-testid="designsummarytab"
                  aria-label="Summary"
                  className={vm.store.currentTab === vm.tabTitles.summary ? 'active' : ''}
                  onClick={() => {
                    vm.store.currentTab = vm.tabTitles.summary;
                  }}
                >
                  <strong>Summary</strong>
                </button>
              </li>

              <li
                className="table-name"
                hidden={
                  !vm.store.hasDesign || !vm.store.newDesignForm.type || vm.store.newDesignForm.name.length === 0
                }
              >
                <button
                  data-testid="newdesigntab"
                  className={vm.store.currentTab === vm.tabTitles.editForm ? 'active' : ''}
                  onClick={() => {
                    vm.store.currentTab = vm.tabTitles.editForm;
                  }}
                >
                  <strong hidden={vm.store.editDesign}>{vm.store.newDesignForm.type}</strong>
                  <strong hidden={!vm.store.editDesign}>{vm.store.newDesignForm.name}</strong>
                </button>
              </li>
            </ul>
            <FlatButton
              className="design-settings"
              aria-label="Design Settings"
              onClick={vm.handleClick}
              iconOnly={mdiAccountCog}
            ></FlatButton>
          </div>
          {vm.store.currentTab === vm.tabTitles.summary ? props.summaryComponent : null}
          {vm.store.currentTab === vm.tabTitles.editForm ? props.editFormComponent : null}
        </div>
      </CollapseMenu>
    </>
  );
};

export const DesignTabContainer = observer(DesignTabContainerComponent);
